import { Role } from "../types";
import { contentTypeIds } from "../../types";

import * as r from "../role-helpers";

const communityTabEntries = [
  contentTypeIds.communityCreator,
  contentTypeIds.communityVideoEntry,
  contentTypeIds.communityLivestreamEntry,
];

const communityTabAdmin: Role = {
  type: "CommunityTabAdmin",
  name: "Community Tab Administrator",
  description:
    "Allow manually editing content on the community tab, normally managed automatically",
  policies: [
    r.allowEverythingForOwnContent(),
    r.allowDeleteForOwnContent(),

    ...communityTabEntries.flatMap((e) => [
      r.allowCreateForContentType(e),
      r.allowReadForContentType(e),
      r.allowPublishUnpublishForContentType(e),
    ]),

    ...r.assetPermissions(),
  ],
  permissions: {
    ContentModel: ["read"],
    Settings: [],
    ContentDelivery: [],
    Environments: [],
    EnvironmentAliases: [],
    Tags: [],
  },
};

export { communityTabAdmin };
